import { useState, useEffect, useRef } from 'react';
import { Language } from '../config/types';
import { sendAnalytics } from '../utils/sendAnalytics';

export const useUserAnalytics = (currentLanguage: Language) => {
  const [analyticsResponse, setAnalyticsResponse] = useState<string>('Share your thoughts...');
  const isFirstRender = useRef(true);
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    const collectAndSendData = async () => {
      try {
        // Only send analytics if it's the first render
        if (isFirstRender.current) {
          const response = await sendAnalytics({ currentLanguage });
          if (isMounted.current) {
            setAnalyticsResponse(response.content);
            isFirstRender.current = false;
          }
        }
      } catch (error) {
        console.error('Analytics error:', error);
        if (isMounted.current) {
          setAnalyticsResponse('Share your thoughts...');
        }
      }
    };

    collectAndSendData();

    return () => {
      isMounted.current = false;
    };
  }, [currentLanguage]);

  return analyticsResponse;
};